import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var Icon = function (_a) {
    var icon = _a.icon, size = _a.size, title = _a.title, color = _a.color, width = _a.width;
    return (_jsx(FontAwesomeIcon, { "aria-hidden": true, title: title, icon: icon, size: size, color: color, width: width }));
};
export default Icon;
